//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetKvlist } from '@/api/kv.js';
import { whereGql } from '@/graphql/util';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customBranch: '',
      miniBranch: '',
      remark: '',
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.name = '';
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      if (!this.customBranch || (this.tab === 'mini' && !this.miniBranch)) {
        this.$message.error('请输入分支名');
        return;
      }
      GetKvlist({
        limit: 1,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: `pipeline_default_json_${this.tab}`,
          },
        ]),
      })
        .then((res) => {
          const kv = res.kv._data[0];
          const preData = JSON.parse(kv.value);
          const data = {
            mini_branch: '',
            mini_appid: '',
            ...preData,
            custom_branch: this.customBranch,
            remark: this.remark,
          };
          if (this.tab === 'mini') {
            data.mini_branch = this.miniBranch;
          }
          console.log('meow', data);
          this.$emit('submit', data);
        })
        .catch((e) => {
          console.error(e);
          this.$message.error('获取配置失败');
        });
    },
  },
};
